import { RepositoryFactory } from '@/api/factory/repositoryFactory'
const InterestRepository = RepositoryFactory.get('interest')

const state = {
  interests: {},
  listInterest: []
};

const actions = {
  async fetchInterest({ commit }, params = {}) {
    const res = await InterestRepository.fetch(params)
    commit('setInterest', res.data)
    return res.data
  },
  async addMultipleInterest({ commit }, params = {}) {
    const res = await InterestRepository.addMultipleInterest({
      ...params,
    });
    commit("appendInterests", res.data);
    return res.data;
  },
};

const mutations = {
  appendInterests(state, interests) {
    const newIntersts = interests.reduce(
      (acc, cur) => ({ ...acc, [cur.id]: cur }),
      {}
    );
    state.interests = {
      ...state.interests,
      ...newIntersts
    }
  },
  setInterest(state, data) {
    state.listInterest = data
  }
};

const getters = {
  getInterests: (state) => {
    return Object.values(state.interests);
  },
  getListInterests: (state) => {
    return state.listInterest
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
